import { webApiEndpoints } from "../config";
import { mapper } from "../helpers/mapper.helper";
import { } from "../helpers/webapi.helper";
import { AppCategories, AppRequestType, CommentOriginType, DocPage, DocPageComment, ResourceType } from "../types";

const category: AppCategories = 'documentation'

export const documentationAdapter = {

    getPublicResource: (): AppRequestType<DocPage>[typeof category]['publicResource'] => ({
        endpoint: webApiEndpoints[category].publicResource,
        input: null,
        output: (datos) => mapper.apiDocumentPage(datos, 0),
        hideError: true
    }),

    getDocumentation: (idContent: number, withComments: boolean = false): AppRequestType<DocPage>[typeof category]['referencedDocument'] => ({
        endpoint: webApiEndpoints[category].referencedDocument,
        input: ({ id: idContent.toString(), comentarios: withComments }),
        output: (datos) => mapper.apiDocumentPage(datos, idContent)
    }),

    getComments: (idContent: number): AppRequestType<DocPageComment[]>[typeof category]['listComments'] => ({
        endpoint: webApiEndpoints[category].listComments,
        input: ({ id: idContent.toString() }),
        output: (datos) => datos.map(mapper.apiDocumentComment)
    }),

    addComment: (data: DocPageComment, origin: CommentOriginType): AppRequestType<DocPageComment>[typeof category]['addComment'] => ({
        endpoint: webApiEndpoints[category].addComment,
        input: (mapNewDocCommentApi(data, origin)),
        output: (datos) => mapper.apiDocumentComment(datos)
    }),

    editComment: (data: DocPageComment): AppRequestType<DocPageComment>[typeof category]['editComment'] => ({
        endpoint: webApiEndpoints[category].editComment,
        input: ({
            id: data.id || 0,
            contenido: data.content,
            idPadre: data.parentCommentId,
            idPagina: data.pageId,
            comentarios: [],
            version: data.version
        }),
        output: (datos) => mapper.apiDocumentComment(datos)
    }),

    deleteComment: (data: DocPageComment): AppRequestType<DocPageComment>[typeof category]['deleteComment'] => ({
        endpoint: webApiEndpoints[category].deleteComment,
        input: ({
            id: data.id || 0,
            contenido: data.content,
            idPadre: data.parentCommentId,
            idPagina: data.pageId,
            comentarios: [],
            version: data.version
        }),
        output: (datos) => mapper.apiDocumentComment(datos)
    }),

    createCommentResource: (resource: ResourceType, data: DocPageComment): AppRequestType<DocPageComment>[typeof category]['createCommentResource'] => ({
        endpoint: webApiEndpoints[category].createCommentResource,
        input: ({
            recurso: {
                descripcion: resource.description,
                etiqueta: resource.label,
                id: resource.id,
                idRepositorio: resource.idRepository,
                nombre: resource.name || '',
                versiones: [],
                menuAsociado: []
            },
            comentarioAsociado: mapNewDocCommentApi(data, 'resource')
        }),
        output: (datos) => mapper.apiDocumentComment(datos)
    })
}

function mapNewDocCommentApi(data: DocPageComment, origin: CommentOriginType) {
    return {
        id: data.id || 0,
        contenido: data.content,
        idPadre: data.parentCommentId,
        idPagina: data.pageId,
        comentarios: [],
        version: 0,
        tituloPrincipal: data.pageTitle,
        usuarioComentarioPadre: data.parentCommentUser,
        origen: origin
    }
}